export * from './tour-stati-list.component';
export * from './tour-stati-list.component.module';